import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

import { config } from "../../services/configHeader";

const baseUrl = process.env.REACT_APP_BASE_URI;

const user = localStorage.getItem("user_data")
  ? JSON.parse(localStorage.getItem("user_data"))
  : null;
// const userId = user?.user_id;
const accountType = user?.account_type;

const initialState = {
  payrollModListLoading: false,
  payrollModListSuccess: false,
  payrollModListError: false,
  payrollModListMessage: null,
  payrollModListData: null,

  payrollModListStaffLoading: false,
  payrollModListStaffSuccess: false,
  payrollModListStaffError: false,
  payrollModListStaffMessage: null,
  payrollModListStaffData: null,
};

export const getPayrollModuleList = createAsyncThunk(
  "getPayrollModuleList",
  async (path) => {
    return await axios
      .get(`${baseUrl}${path}`, config)
      .then((response) => {
        return response;
      })
      .catch((error) => {
        if (!navigator.onLine) {
          let data = {
            response: {
              data: [],
              message: "No Internet Connection Found",
              success: false,
            },
          };
          return data;
        } else {
          return error;
        }
      });
  }
);

export const getPayrollModuleStaffList = createAsyncThunk(
  "getPayrollModuleStaffList",
  async (path) => {
    return await axios
      .get(`${baseUrl}${path}`, config)
      .then((response) => {
        return response;
      })
      .catch((error) => {
        if (!navigator.onLine) {
          let data = {
            response: {
              data: [],
              message: "No Internet Connection Found",
              success: false,
            },
          };
          return data;
        } else {
          return error;
        }
      });
  }
);

const payrollSlice = createSlice({
  name: "payroll",
  initialState,

  reducers: {
    payrollInitState: (state) => {
      state.payrollModListLoading = false;
      state.payrollModListSuccess = false;
      state.payrollModListError = false;
      state.payrollModListMessage = null;
      state.payrollModListData = null;
    },
    payrollStaffIntState: (state) => {
      state.payrollModListStaffLoading = false;
      state.payrollModListStaffSuccess = false;
      state.payrollModListStaffError = false;
      state.payrollModListStaffMessage = null;
      state.payrollModListStaffData = null;
    },
  },

  extraReducers: (builder) => {
    builder.addCase(getPayrollModuleList.pending, (state, action) => {
      state.payrollModListLoading = true;
      state.payrollModListSuccess = false;
      state.payrollModListError = false;
      state.payrollModListMessage = null;
      state.payrollModListData = null;
    });

    builder.addCase(getPayrollModuleList.fulfilled, (state, action) => {
      state.payrollModListLoading = false;
      state.payrollModListSuccess = true;
      state.payrollModListError = false;
      state.payrollModListMessage =
        action.payload.status == 200
          ? action.payload.data.message
          : action.payload.response.data.message;
      state.payrollModListData =
        action.payload.status == 200
          ? action.payload.data.data
          : action.payload.response.data.data;
    });

    builder.addCase(getPayrollModuleList.rejected, (state, action) => {
      state.payrollModListLoading = false;
      state.payrollModListSuccess = true;
      state.payrollModListError = false;
      state.payrollModListMessage = null;
      state.payrollModListData = null;
    });
    // -----------------------------------------
  },
});

export const { payrollInitState } = payrollSlice.actions;

export default payrollSlice.reducer;
